import ChangePasswordForm from 'components/me/ChangePassword'

const ChangePassword = () =>
  <ChangePasswordForm />

export default ChangePassword
